<h3 mat-dialog-title>นโยบายการจัดเก็บ ใช้ เปิดเผย และจัดการข้อมูลส่วนบุคคล</h3>
<mat-dialog-content>
  <article>
    <header>
      <h4>ประกาศความเป็นส่วนตัวสำหรับการลงทะเบียนรับส่วนลด</h4>
      <p>
        บริษัท ต.สยาม คอมเมอร์เชียล จำกัด (“บริษัทฯ”) ในฐานะผู้ควบคุมข้อมูลส่วนบุคคล จัดทำประกาศนี้เพื่อแจ้งรายละเอียดเกี่ยวกับการเก็บรวบรวม
        ใช้ และเปิดเผยข้อมูลส่วนบุคคลในการลงทะเบียนรับและใช้สิทธิ์ส่วนลด
      </p>
    </header>

    <section>
      <h5>1. ข้อมูลส่วนบุคคลที่เก็บรวบรวมและวัตถุประสงค์การใช้งาน</h5>
      <p>บริษัทฯ เก็บรวบรวมข้อมูลจากการลงทะเบียนของท่าน และข้อมูลการใช้สิทธิ์จากระบบหรือร้านค้าที่ร่วมรายการ ได้แก่</p>
      <ul>
        <li>
          <strong>ข้อมูลลงทะเบียน:</strong>
          ชื่อ–นามสกุล เบอร์โทรศัพท์ เลขทะเบียนรถ และจังหวัดของทะเบียนรถ
        </li>
        <li>
          <strong>ข้อมูลกิจกรรม:</strong>
          โค้ดส่วนลด วันเวลาที่ลงทะเบียน สถานะการส่งโค้ด สถานะการรับและใช้สิทธิ์ รวมถึงวันเวลาและร้านค้าที่ใช้สิทธิ์
        </li>
      </ul>
      <p>
        บริษัทฯ ใช้ข้อมูลดังกล่าวเพื่อดำเนินการตามคำขอลงทะเบียนและเงื่อนไขแคมเปญ ได้แก่ ตรวจสอบข้อมูลผู้รับสิทธิ์ ออกและส่งโค้ดส่วนลดทาง SMS
        และดำเนินการให้ท่านใช้สิทธิ์กับร้านค้าที่ร่วมรายการ โดยอาศัยฐานสัญญา
      </p>
      <p>
        นอกจากนี้ บริษัทฯ ใช้ข้อมูลเพื่อตรวจสอบการใช้สิทธิ์ซ้ำ ป้องกันการทุจริต ตรวจสอบความผิดปกติ ตอบข้อซักถาม
        และจัดการข้อร้องเรียนหรือข้อพิพาทที่เกี่ยวข้อง โดยอาศัยฐานประโยชน์โดยชอบด้วยกฎหมาย และคำนึงถึงสิทธิและเสรีภาพของท่าน
      </p>
      <p>หากท่านไม่ให้ข้อมูลที่จำเป็น บริษัทฯ อาจไม่สามารถตรวจสอบหรือมอบสิทธิ์ส่วนลดให้ท่านได้</p>
      <p>
        หากบริษัทฯ ประสงค์จะใช้ข้อมูลเพื่อส่งข่าวสารหรือโปรโมชั่นอื่นในอนาคต บริษัทฯ จะขอความยินยอมแยกต่างหาก
        โดยไม่เป็นเงื่อนไขในการรับส่วนลดครั้งนี้
      </p>
    </section>

    <section>
      <h5>2. การจัดเก็บและการเปิดเผยข้อมูล</h5>
      <p>
        บริษัทฯ จัดเก็บข้อมูลบนระบบคลาวด์ในประเทศไทย และจัดให้มีมาตรการรักษาความมั่นคงปลอดภัยที่เหมาะสม
        รวมถึงจำกัดการเข้าถึงเฉพาะผู้ที่จำเป็นต้องใช้ข้อมูลตามหน้าที่
      </p>
      <p>บริษัทฯ อาจเปิดเผยข้อมูลเท่าที่จำเป็นแก่บุคคลหรือหน่วยงานต่อไปนี้</p>
      <ul>
        <li>
          <strong>ผู้ให้บริการระบบคลาวด์ ระบบลงทะเบียน และผู้ดูแลระบบ:</strong>
          เพื่อจัดเก็บ ประมวลผล ดูแลการทำงานของระบบ และตรวจสอบปัญหาการลงทะเบียนหรือการใช้สิทธิ์
        </li>
        <li>
          <strong>ผู้ให้บริการสนับสนุนผู้ใช้งานที่บริษัทฯ มอบหมาย:</strong>
          เพื่อให้ข้อมูล ตอบข้อซักถาม และประสานงานเกี่ยวกับการลงทะเบียนหรือการใช้สิทธิ์
        </li>
        <li>
          <strong>ผู้ให้บริการส่ง SMS:</strong>
          เพื่อส่งโค้ดหรือข้อความเกี่ยวกับสิทธิ์ โดยเปิดเผยเฉพาะข้อมูลที่จำเป็นต่อการส่งข้อความ
        </li>
        <li>
          <strong>ร้านค้าหรือตัวแทนจำหน่ายที่ร่วมรายการ:</strong>
          เพื่อตรวจสอบข้อมูลผู้รับสิทธิ์และรถ บันทึกการใช้สิทธิ์ และดำเนินการให้ส่วนลด
        </li>
        <li>
          <strong>หน่วยงานภาครัฐที่มีอำนาจตามกฎหมาย:</strong>
          เมื่อบริษัทฯ มีหน้าที่ต้องเปิดเผยข้อมูลตามกฎหมาย
        </li>
      </ul>
      <p>
        บริษัทฯ กำหนดให้ผู้ให้บริการที่ประมวลผลข้อมูลแทนบริษัทฯ ใช้ข้อมูลตามคำสั่งและวัตถุประสงค์ที่กำหนด
        พร้อมมีมาตรการคุ้มครองข้อมูลที่เหมาะสม
      </p>
    </section>

    <section>
      <h5>3. ระยะเวลาการเก็บรักษาข้อมูล</h5>
      <p>
        บริษัทฯ เก็บรักษาข้อมูลตลอดระยะเวลาแคมเปญ และภายหลังสิ้นสุดแคมเปญเท่าที่จำเป็น แต่ไม่เกิน 3 ปีนับจากวันสิ้นสุดแคมเปญ
        เพื่อการตรวจสอบสิทธิ์ การทุจริต ข้อร้องเรียน และข้อพิพาทที่เกี่ยวข้อง โดยจะทบทวนความจำเป็นในการเก็บข้อมูล
        และลบข้อมูลก่อนครบกำหนดหากหมดความจำเป็น
      </p>
      <p>
        หากมีข้อร้องเรียน ข้อพิพาท หรือหน้าที่ตามกฎหมายที่จำเป็นต้องเก็บข้อมูลต่อ บริษัทฯ
        จะเก็บเฉพาะข้อมูลที่เกี่ยวข้องเท่าที่จำเป็นจนกว่าเรื่องดังกล่าวจะสิ้นสุด หรือครบระยะเวลาที่กฎหมายกำหนด
      </p>
      <p>
        เมื่อพ้นระยะเวลาเก็บรักษาหรือหมดความจำเป็น บริษัทฯ จะดำเนินการลบ ทำลาย
        หรือทำให้ข้อมูลไม่สามารถระบุตัวบุคคลได้ตามหลักเกณฑ์ที่กฎหมายกำหนด
      </p>
    </section>

    <section>
      <h5>4. สิทธิของเจ้าของข้อมูลส่วนบุคคล</h5>
      <p>ท่านสามารถติดต่อบริษัทฯ เพื่อใช้สิทธิดังต่อไปนี้ ภายใต้เงื่อนไขและข้อยกเว้นตามกฎหมาย</p>
      <ul>
        <li>ขอเข้าถึงและรับสำเนาข้อมูลส่วนบุคคล</li>
        <li>ขอแก้ไขข้อมูลให้ถูกต้อง เป็นปัจจุบัน และสมบูรณ์</li>
        <li>ขอรับหรือโอนย้ายข้อมูลส่วนบุคคลในกรณีที่กฎหมายกำหนด</li>
        <li>ขอให้ลบ ทำลาย หรือทำให้ข้อมูลไม่สามารถระบุตัวบุคคลได้</li>
        <li>ขอระงับการใช้ข้อมูลส่วนบุคคล</li>
        <li>คัดค้านการประมวลผลข้อมูลที่อาศัยฐานประโยชน์โดยชอบด้วยกฎหมาย</li>
        <li>ร้องเรียนต่อคณะกรรมการผู้เชี่ยวชาญตามกฎหมายคุ้มครองข้อมูลส่วนบุคคล ผ่านสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล</li>
      </ul>
      <p>
        บริษัทฯ อาจขอข้อมูลเท่าที่จำเป็นเพื่อยืนยันตัวตนก่อนดำเนินการตามคำขอ และจะแจ้งผลพร้อมเหตุผลในกรณีที่ไม่สามารถดำเนินการได้ตามกฎหมาย
      </p>
    </section>

    <section>
      <h5>5. ช่องทางการติดต่อ</h5>
      <p>หากมีข้อสงสัยเกี่ยวกับประกาศนี้ หรือต้องการใช้สิทธิเกี่ยวกับข้อมูลส่วนบุคคล กรุณาติดต่อ</p>
      <address>
        <strong>บริษัท ต.สยาม คอมเมอร์เชียล จำกัด</strong>
        <br />
        ที่อยู่: 88/8 หมู่ที่ 5 ตำบลท่าไม้ อำเภอกระทุ่มแบน จังหวัดสมุทรสาคร 74110
        <br />
        อีเมล:
        <a href="mailto:admin@tsiam.co.th">admin&#64;tsiam.co.th</a>
        <br />
        โทรศัพท์:
        <a href="tel:+6620248091">02 024 8091</a>
      </address>
    </section>
  </article>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button matButton mat-dialog-close>ปิด</button>
</mat-dialog-actions>
